module.exports = __webpack_public_path__ + "img/bg.c95909df.webp";